import "../css/imagegallery.css";
import { useState, useEffect, useRef } from "react";

function ImageGallery({ gallery, id }) {
  const [currentIndex, setCurrentIndex] = useState(0);
  const scrollRef = useRef(null);

  // Autoplay con limpieza correcta
  useEffect(() => {
    if (!gallery || gallery.length === 0) return;

    const interval = setInterval(() => {
      const nextIndex = (currentIndex + 1) % gallery.length;
      scrollToIndex(nextIndex);
    }, 4000);

    return () => clearInterval(interval);
  }, [currentIndex, gallery.length]);

  const scrollToIndex = (index) => {
    const element = scrollRef.current;
    if (element) {
      element.scrollTo({
        left: index * element.offsetWidth,
        behavior: "smooth",
      });
      setCurrentIndex(index);
    }
  };

  if (!gallery || gallery.length === 0) return null;

  return (
    <div className="gallery-main-container"> {/* CONTENEDOR MAESTRO */}
      <div className="wrapper-gallery">
        <div 
          ref={scrollRef} 
          className="gallery-container"
          id={`wrappergallery-${id}`}
        >
          {gallery.map((url, index) => (
            <div className="item-gallery" key={index}>
              <img src={url} alt={`Imagen ${index + 1}`} />
            </div>
          ))}
        </div>
      </div>

      {/* Los indicadores ahora están DENTRO del flujo del contenedor maestro */}
      <div className="gallery-indicators">
        {gallery.map((_, index) => (
          <span
            key={index}
            className={`indicator ${index === currentIndex ? "active" : ""}`}
            onClick={() => scrollToIndex(index)}
          >
            ●
          </span>
        ))}
      </div>
    </div>
  );
}

export default ImageGallery;